(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hn-halloween-product-coupons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-halloween-offers')) {
    customElements.define('hn-halloween-offers', class extends HTMLElement {
      connectedCallback() {
        this.resetTimers = new Set();
        this.onClick = this.handleClick.bind(this);
        this.onVisibility = () => this.checkExpiry();
        this.addEventListener('click', this.onClick);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.checkExpiry();
        this.expiryTimer = window.setInterval(() => this.checkExpiry(), 60000);
      }
      checkExpiry() {
        if (Date.now() >= Date.parse(this.dataset.expires)) this.hidden = true;
      }
      async handleClick(event) {
        const toggle = event.target.closest('[data-offer-toggle]');
        if (toggle && this.contains(toggle)) {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          this.querySelectorAll('[data-extra-offer]').forEach((offer) => { offer.hidden = expanded; });
          return;
        }
        const button = event.target.closest('[data-ticket-code]');
        if (!button || !this.contains(button) || button.dataset.copying) return;
        const code = button.dataset.ticketCode;
        const label = button.querySelector('[data-ticket-label]');
        const hint = this.querySelector('[data-ticket-hint]');
        button.dataset.copying = 'true';
        try {
          await navigator.clipboard.writeText(code);
          if (!this.isConnected) return;
          button.classList.add('is-copied');
          label.textContent = this.dataset.copySuccess;
          hint.textContent = code + ' · ' + this.dataset.copySuccess;
        } catch {
          hint.textContent = this.dataset.copyError + ' ' + code;
          const range = document.createRange();
          range.selectNodeContents(label);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } finally {
          if (!this.isConnected) { delete button.dataset.copying; return; }
          const timer = window.setTimeout(() => {
            button.classList.remove('is-copied');
            label.textContent = code;
            hint.textContent = '';
            delete button.dataset.copying;
            this.resetTimers.delete(timer);
          }, 2200);
          this.resetTimers.add(timer);
        }
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.clearInterval(this.expiryTimer);
        this.resetTimers?.forEach((timer) => window.clearTimeout(timer));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hn-product-detail-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-product-detail-tabs')) {
    customElements.define('hn-product-detail-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.panelContainer = this.querySelector('.hn-detail-tabs__panels');
        this.panelHeight = 0;
        this.syncControl = this.querySelector('.hn-detail-tabs__sync-control');
        this.syncNext = this.syncControl?.querySelector('[data-sync-scroll="next"]');
        this.syncingRails = false;
        this.syncFrame = 0;
        this.syncSource = null;
        if (this.classList.contains('hn-detail-tabs--preview')) {
          const sharedTrack = this.querySelector('[data-shared-rail]');
          this.rails = sharedTrack ? [{ track: sharedTrack, controls: null, previous: null, next: null, overflow: false, canNext: false }] : [];
        } else {
          this.rails = [...this.querySelectorAll('.hn-detail-tabs__items')].map(track => {
            const rail = track.closest('.hn-detail-tabs__rail');
            const controls = rail?.querySelector('.hn-detail-tabs__scroll-controls');
            return {
              track,
              controls,
              previous: controls?.querySelector('[data-scroll="previous"]'),
              next: controls?.querySelector('[data-scroll="next"]'),
              overflow: false,
              canNext: false
            };
          });
        }
        const activeIndex = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
        this.selectTab(Math.max(0, activeIndex));
        this.classList.add('is-ready');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index), options);
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            if (nextIndex === undefined) return;
            event.preventDefault();
            nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
            this.selectTab(nextIndex);
            this.tabs[nextIndex].focus();
          }, options);
        });
        this.rails.forEach(rail => {
          const { track, controls, previous, next } = rail;
          if (!track) return;
          track.addEventListener('scroll', () => {
            this.updateControls(rail);
            if (this.classList.contains('hn-detail-tabs--preview') && !this.syncingRails) this.scheduleSync(rail);
          }, { ...options, passive: true });
          track.addEventListener('keydown', event => {
            if (event.target !== track) return;
            const rtl = getComputedStyle(track).direction === 'rtl';
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              this.scrollItems(rail, (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
            } else if (event.key === 'Home' || event.key === 'End') {
              event.preventDefault();
              track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth * (rtl ? -1 : 1), behavior: this.scrollBehavior() });
            }
          }, options);
          previous?.addEventListener('click', () => this.scrollItems(rail, -1), options);
          next?.addEventListener('click', () => this.scrollItems(rail, 1), options);
          this.updateControls(rail);
        });
        this.syncNext?.addEventListener('click', () => this.scrollItemsTogether(1), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => { this.updateControls(); this.syncPanelHeight(); });
          this.rails.forEach(rail => this.resizeObserver.observe(rail.track));
          this.panels.forEach(panel => this.resizeObserver.observe(panel));
        }
      }
      selectTab(index) {
        const selectedId = this.tabs[index]?.getAttribute('aria-controls');
        if (!selectedId) return;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.setAttribute('data-active', String(index));
        this.panels.forEach(panel => {
          const active = panel.id === selectedId;
          panel.classList.toggle('is-inactive', !active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
          panel.tabIndex = active ? 0 : -1;
          panel.hidden = false;
        });
        this.updateControls();
        this.syncPanelHeight();
      }
      syncPanelHeight() {
        if (!this.panelContainer || this.panels.length < 2) return;
        const active = this.panels.find(panel => !panel.inert);
        const height = Math.ceil(active?.getBoundingClientRect().height || 0);
        if (!height || height === this.panelHeight) return;
        this.panelHeight = height;
        this.panelContainer.style.setProperty('--hn-panel-height', `${height}px`);
      }
      updateControls(railState) {
        const rails = railState ? [railState] : this.rails;
        rails.forEach(rail => {
          const { track, controls, previous, next } = rail;
          if (!track) return;
          if (!track.clientWidth) {
            rail.overflow = false;
            rail.canNext = false;
            if (controls) controls.hidden = true;
            return;
          }
          const items = [...track.children];
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const contentWidth = this.classList.contains('hn-detail-tabs--preview')
            ? track.scrollWidth
            : items.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + Math.max(0, items.length - 1) * gap;
          const overflow = contentWidth > track.clientWidth + 2;
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const position = Math.abs(track.scrollLeft);
          rail.overflow = overflow && maxScroll > 2;
          rail.canNext = rail.overflow && position < maxScroll - 2;
          if (controls && previous && next) {
            controls.hidden = !rail.overflow;
            track.tabIndex = controls.hidden ? -1 : 0;
            previous.disabled = position <= 2;
            next.disabled = !rail.canNext;
          } else track.tabIndex = rail.overflow ? 0 : -1;
        });
        const first = this.rails[0];
        this.setAttribute('data-extra-overflow', String(Boolean(first?.overflow)));
        this.setAttribute('data-extra-previous', String(Boolean(first?.controls && !first.controls.hidden && first.previous && !first.previous.disabled)));
        this.setAttribute('data-extra-next', String(Boolean(first?.canNext)));
        if (this.syncControl && this.syncNext) {
          const canSyncNext = this.rails.some(rail => rail.canNext);
          this.syncControl.hidden = !canSyncNext;
          this.syncNext.disabled = !canSyncNext;
        }
      }
      scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      scheduleSync(source) {
        if (this.rails.length < 2) return;
        this.syncSource = source;
        if (this.syncFrame) return;
        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = 0;
          const leader = this.syncSource;
          this.syncSource = null;
          if (!leader) return;
          const direction = getComputedStyle(leader.track).direction === 'rtl' ? -1 : 1;
          const logicalLeft = Math.max(0, leader.track.scrollLeft * direction);
          this.syncingRails = true;
          this.rails.forEach(rail => {
            if (rail === leader) return;
            const max = Math.max(0, rail.track.scrollWidth - rail.track.clientWidth);
            const nextLeft = Math.min(max, logicalLeft) * direction;
            if (Math.abs(rail.track.scrollLeft - nextLeft) > 0.5) rail.track.scrollLeft = nextLeft;
          });
          this.syncingRails = false;
        });
      }
      scrollItemsTogether(direction) {
        this.rails.forEach(rail => this.scrollItems(rail, direction));
      }
      scrollItems(rail, direction) {
        const row = this.classList.contains('hn-detail-tabs--preview') ? rail.track.querySelector('.hn-detail-tabs__items') : rail.track;
        const item = row?.firstElementChild;
        if (!item) return;
        const style = getComputedStyle(row);
        const step = item.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        rail.track.scrollBy({
          left: direction * step * (style.direction === 'rtl' ? -1 : 1),
          behavior: this.scrollBehavior()
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hn-product-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-spec-scroller')) {
    customElements.define('hn-spec-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort(); this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.hn-spec-track');
        this.controls = this.querySelector('.hn-spec-controls');
        this.previous = this.querySelector('[data-spec-step="-1"]');
        this.next = this.querySelector('[data-spec-step="1"]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: this.behavior() });
          }
        }, options);
        if ('ResizeObserver' in window) { this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.track); }
        this.update();
      }
      behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const first = this.track?.firstElementChild; if (!first) return;
        const style = getComputedStyle(this.track);
        this.track.scrollBy({ left: direction * (first.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0)) * (style.direction === 'rtl' ? -1 : 1), behavior: this.behavior() });
      }
      update() {
        if (!this.track || !this.controls) return;
        const items = [...this.track.children];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const contentWidth = items.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + Math.max(0, items.length - 1) * gap;
        const overflow = contentWidth > this.track.clientWidth + 2;
        this.setAttribute('data-overflow', String(overflow));
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = !this.track.clientWidth || !overflow || max <= 2;
        this.track.tabIndex = this.controls.hidden ? -1 : 0;
        const at = Math.abs(this.track.scrollLeft); this.previous.disabled = at <= 2; this.next.disabled = at >= max - 2;
        this.setAttribute('data-can-previous', String(!this.controls.hidden && !this.previous.disabled));
        this.setAttribute('data-can-next', String(!this.controls.hidden && !this.next.disabled));
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
